import { StackScreenProps } from "@react-navigation/stack";
import { ProductActionsSelectVariantTemplateOptionValuesRootParamList } from "../../../../types";
import {
  Button,
  Page,
  useFlashMessages,
} from "@towersystems/roam-common-native";
import { CreateVariantsFromTemplateForm } from "../../components/CreateVariantsFromTemplateForm";
import { CreateVariantsFromTemplateFormValues } from "../../components/CreateVariantsFromTemplateForm/types";
import React from "react";
import { useFormContext } from "react-hook-form";
import { Colors } from "react-native-ui-lib";
import { useCreateVariantsFromTemplateFormContextProvider } from "../../components/CreateVariantsFromTemplateForm/hooks";
import { useResetFormOnRootError } from "../../utils";

export type ProductActionsSelectVariantTemplateOptionValuesScreenProps =
  StackScreenProps<
    ProductActionsSelectVariantTemplateOptionValuesRootParamList,
    "ProductActionsSelectVariantTemplateOptionValuesScreen"
  >;

export const ProductActionsSelectVariantTemplateOptionValuesScreen = ({
  navigation,
  route,
}: ProductActionsSelectVariantTemplateOptionValuesScreenProps) => {
  const maybeFormContext = useCreateVariantsFromTemplateFormContextProvider();

  const formContext = useFormContext<CreateVariantsFromTemplateFormValues>();
  const { handleSubmit, formState, setError, reset, watch } = formContext;

  useResetFormOnRootError({
    context: formContext,
  });

  const {
    isDirty,
    errors,
    isLoading,
    isSubmitting,
    isValid,
    isSubmitSuccessful,
  } = formState;

  const flashMessagesContext = useFlashMessages();

  const disabled =
    !isDirty ||
    isLoading ||
    isSubmitting ||
    isValid == false ||
    isSubmitSuccessful;

  const handleOnSubmit = React.useCallback(
    async (values: CreateVariantsFromTemplateFormValues) => {
      try {
        await maybeFormContext?.handleOnSubmit(values);
      } catch (err: any) {
        const msg = err?.message ?? "Something went wrong";
        flashMessagesContext.showMessage({
          message: msg,
          severity: "error",
        });
        setError("root", {
          type: "serverError",
          message: msg,
        });
      }
    },
    []
  );

  const footerMarkup = (
    <Button
      disabled={disabled}
      label="Create Variant"
      backgroundColor={Colors.action}
      color="white"
      onPress={handleSubmit(handleOnSubmit)}
    ></Button>
  );

  return (
    <Page title="Enter variant options" footer={footerMarkup}>
      <CreateVariantsFromTemplateForm />
    </Page>
  );
};
